import { BrowserRouter, Route, Routes } from "react-router-dom";
import Login from "./../views/Login";
import PageNotFound from "../views/PageNotFound";
import OptionService from "../views/OptionService/OptionService";
import Dashboard from "../views/OptionDashboard/Dashboard";
import Reportes from "../views/Reportes/Reportes";
import { PrivateRoute } from "./PrivateRoute";
import { PublicRoute } from "./PublicRoute";
import AgentsHome from "../views/AgentsHome/AgentsHome";
import ModalView from "../views/Modal";
import Search from "../views/Search/Search";
import SearchAdvanced from "../views/Search/SearchAdvanced";

import MiCuenta from "../components/molecules/MiCuenta";

import Phone from "../views/Phone";

import VisitScreen from "../views/Reportes/components/VisitScreen_m";

export const AppRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />

        <Route
          path="/option-dashboard"
          element={
            <PrivateRoute
              allowedClasses={[
                "_ADMIN_",
                "_ADMIN_VISITS_",
                "_COADMIN_",
                "_SUPERVISOR_",
                "_ADMIN_MOBILE_",
                "_MASTER_",
              ]}
              allowedTypes={["_ADJUSTER_"]}
            >
              <Dashboard />
            </PrivateRoute>
          }
        />

        <Route
          path="/option-service/:id"
          element={
            <PrivateRoute
              allowedClasses={["_COADMIN_", "_SUPERVISOR_", "_ADMIN_"]}
              allowedTypes={["_ADJUSTER_"]}
            >
              <OptionService />
            </PrivateRoute>
          }
        />

        <Route path="/trackadjuster" element={<VisitScreen />} />

        {/* <Route
          path="/option-service-master/:id"
          element={
            <PrivateRoute allowedClasses={["_MASTER_"]}>
              <OptionServiceMaster />
            </PrivateRoute>
          }
        /> */}
        <Route
          path="/cabin"
          element={
            <PrivateRoute
              allowedClasses={["_ADMIN_", "_SUPERVISOR_"]}
              allowedTypes={["_ADJUSTER_"]}
            >
              <Reportes />
            </PrivateRoute>
          }
        />

        <Route
          path="/buscador"
          element={
            <PrivateRoute
              allowedClasses={[
                "_ADMIN_",
                "_ADMIN_VISITS_",
                "_COADMIN_",
                "_SUPERVISOR_",
                "_ADMIN_MOBILE_",
              ]}
              allowedTypes={["_ADJUSTER_"]}
            >
              <Search />
            </PrivateRoute>
          }
        />

        <Route
          path="/buscador-avanzado"
          element={
            <PrivateRoute
              allowedClasses={[
                "_ADMIN_",
                "_ADMIN_VISITS_",
                "_COADMIN_",
                "_SUPERVISOR_",
                "_ADMIN_MOBILE_",
              ]}
              allowedTypes={["_ADJUSTER_"]}
            >
              <SearchAdvanced />
            </PrivateRoute>
          }
        />

        <Route
          path="/calls"
          element={
            <PrivateRoute
              allowedClasses={[
                "_ADMIN_",
                "_ADMIN_VISITS_",
                "_COADMIN_",
                "_SUPERVISOR_",
                "_ADMIN_MOBILE_",
              ]}
            >
              <Phone />
            </PrivateRoute>
          }
        />

        <Route
          path="/modal"
          element={
            <PrivateRoute
              allowedClasses={[
                "_ADMIN_",
                "_ADMIN_VISITS_",
                "_COADMIN_",
                "_SUPERVISOR_",
                "_ADMIN_MOBILE_",
              ]}
            >
              <ModalView />
            </PrivateRoute>
          }
        />
        <Route
          path="/agents-home"
          element={
            <PrivateRoute
              allowedClasses={["_AGENT_"]}
              allowedTypes={["_CALLS_"]}
            >
              <AgentsHome />
            </PrivateRoute>
          }
        />

        <Route
          path="/mi-cuenta"
          element={
            <PrivateRoute
              allowedClasses={[
                "_ADMIN_",
                "_ADMIN_VISITS_",
                "_COADMIN_",
                "_SUPERVISOR_",
                "_ADMIN_MOBILE_",
                "_AGENT_",
              ]}
              allowedTypes={["_ADJUSTER_", "_CALLS_"]}
            >
              <MiCuenta />
            </PrivateRoute>
          }
        />

        {/* 👇️ only match this when no other routes match */}
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </BrowserRouter>
  );
};
